import { useState } from "react";
import { useTranslation } from "react-i18next";
import { resetPassword } from "../Data/dataApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";



const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const { t } = useTranslation();

  const query = new URLSearchParams(window.location.search);
  const email = query.get("email") || "";
  const token = query.get("token") || "";

  // 🔒 validation comme RegisterForm
  const validateForm = (): boolean => {
    const newErrors: any = {};
    let valid = true;

    if (!password) {
      newErrors.password = t("resetPassword.error-password-required");
      valid = false;
    } else if (password.length < 6) {
      newErrors.password = t("resetPassword.error-min-length");
      valid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = t("resetPassword.error-confirm-required");
      valid = false;
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = t("resetPassword.error-mismatch");
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) return;
    setLoading(true);  // 🔥 start loading

    try {
      await resetPassword(email, token, password);
      toast.success(t("resetPassword.success"));
      
      // 👉 redirection vers login
      navigate("/login");
    } 
    catch (error) {
      setLoading(true);  // 🔥 start loading
      toast.error(t("resetPassword.error-general"));
    } 
    finally{
      setLoading(false);  // 🔥 stop loading
    }
  };

  return (
    <div className="forgot-container">
      <form className="forgot-form" onSubmit={handleSubmit}>

        <h2>{t("resetPassword.title")}</h2>

        {/* PASSWORD */}
        <div className="form-group">
          <label>{t("resetPassword.password")}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t("resetPassword.placeholder-password")}
          />
          {errors.password && (
            <p className="error">{errors.password}</p>
          )}
        </div>

        {/* CONFIRM PASSWORD */}
        <div className="form-group">
          <label>{t("resetPassword.confirmPassword")}</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder={t("resetPassword.placeholder-confirmPassword")}
          />
          {errors.confirmPassword && (
            <p className="error">{errors.confirmPassword}</p>
          )}
        </div>

        {/* BUTTON */}
        <button className={`button-blue ${loading ? 'loading' : ''}`} id='button-login' type="submit" disabled={loading}>
          {loading ? "" : t("resetPassword.send")}
        </button>

        {/* LINK */}
        <div className="forgot-link">
          <a href="/login">{t("resetPassword.return")}</a>
        </div>

      </form>
    </div>
  );
};

export default ResetPassword;